import { FormInputText } from 'feature/formComponents'
import styles from '../CompanyRegistration.module.scss'

export function DirectorSection() {
  return (
    <div className={styles.companyRegistration__section}>
      <h3 className={styles.companyRegistration__sectionTitle}>Руководитель</h3>
      <FormInputText
        name='directorFullName'
        inputProps={{
          label: 'ФИО руководителя',
          required: true,
          placeholder: 'Иванов Иван Иванович',
          inputProps: { maxLength: 100 },
          'data-testid': 'company-reg-director-full-name',
        }}
      />
      <FormInputText
        name='directorPosition'
        inputProps={{
          label: 'Должность',
          required: true,
          placeholder: 'Генеральный директор',
          inputProps: { maxLength: 128 },
          'data-testid': 'company-reg-director-position',
        }}
      />
    </div>
  )
}
